<template>
    <CustomHeader :text="$t('activityName.first_recharge')" :show-history="true" @openHistoryPopup="openHistoryPopup" />
    <img class="bg-top-img" :src="dataSet.bannerIcon">
    <div class="firstRecharge">{{ $t('activity.firstRecharge') + ': ' +
        formatCurrency(dataSet.firstRechargeAmount) }}</div>
    <div class="container">
        <img v-if="dataSet.showLeft" src="@/assets/home/game_arrow_white.png"
            style="width: 5%;position: absolute;top: 2vh; z-index: 200;" @click="scrollLeft">
        <img v-if="dataSet.showRight" src="@/assets/home/game_arrow_white.png" @click="scrollRight"
            style="width: 5%;position: absolute;transform: rotate(180deg);right:0;top: 2vh; z-index: 200;">
        <div v-if="dataSet.recordList.length > 0">
            <div class="content">
                <div v-for="(i, index) in dataSet.recordList" :key="index" class="image-wrapper">
                    <DayList :currenyLable="true" :valueOne="i?.coin" :valueTwo="i?.turnover"
                        :labelOne="'dayList.giftAmount'" :labelTwo="'dayList.turnoverTimes'" :activityStatus="i?.status"
                        :time="i?.rewardDate" @getClaim="getClaim" :available-amount="i?.availableAmount"
                        :given-amount="i?.givenAmount" />
                </div>
            </div>
        </div>
        <van-tabs v-if="dataSet.isShowTabs" v-model:active="active" sticky :ellipsis="false" ref="tabsRef"
            @rendered="checkScroll">
            <van-tab v-for="(item, index) in dataSet.firstRechargeConfig?.config" :key="index" :title="item.title"
                :name="index">
                <div class="content">
                    <div class="immidiateDepositBtn">
                        <div class="depositBtn" @click="goToDeposit(item.amount)"> {{ $t('activity.immediateDeposit') }} : {{ item.amount }}</div>
                    </div>
                    <div v-for="(i, index) in item.days" :key="index" class="image-wrapper">
                        <DayList :currenyLable="true" :day="i.day" :valueOne="i.gift ? i.gift : 0"
                            :valueTwo="i.turnover_times" :labelOne="'dayList.giftAmount'"
                            :labelTwo="'dayList.turnoverTimes'" :activityStatus="i.activeStatus" />
                    </div>
                </div>
            </van-tab>
        </van-tabs>
        <div v-else v-for="(item, index) in dataSet.firstRechargeConfig?.config" :key="index" :title="item?.title"
            :name="index">
            <div class="content">
                <div v-for="(i, index) in item?.days" :key="index" class="image-wrapper">
                    <DayList :currenyLable="true" :day="i?.day" :valueOne="i?.gift ? i?.gift : 0"
                        :valueTwo="i?.turnover_times" :labelOne="'dayList.giftAmount'"
                        :labelTwo="'dayList.turnoverTimes'" :activityStatus="i?.activeStatus" />
                </div>
            </div>
        </div>
        <NoData v-if="!dataSet.firstRechargeConfig && dataSet.recordList.length == 0" />
        <div class="bottom_text">
            <van-row style="padding-bottom: 10px;">
                <van-col span="6">
                    <div class="line1"></div>
                </van-col>
                <van-col span="12" class="title">
                    <div>{{ $t('common.activityTitle') }}</div>
                </van-col>
                <van-col span="6">
                    <div class="line2"></div>
                </van-col>
            </van-row>
            <div class="line_text" v-for="(item, index) in dataSet.formattedMessages" :key="index" v-html="item">
            </div>
        </div>
        <CashbackHistoryPopup ref="histryPopupRef" :list="dataSet.historyList" :title="$t('activity.lossTotal')"
            @resetHistoryData="resetHistoryData" :isUseFirstRecharge="true" />
    </div>
</template>

<script setup lang="ts">
import { ref, defineExpose, defineProps, defineEmits } from 'vue';
import { formatCurrency } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import DayList from '../components/common/dayList.vue';
import NoData from '../components/common/noData.vue';
import CashbackHistoryPopup from '../components/common/cashbackHistoryPopup.vue';
import { FirstRechargeData } from '@/view/firstRecharge/supportScript';

const histryPopupRef = ref()
const active = ref(0);
const props = defineProps<{
    dataSet: FirstRechargeData
}>()

const emits = defineEmits(['checkScroll', 'scrollLeft', 'scrollRight', 'getClaim', 'goToDeposit'])

const setActive = (value : number) => {
    active.value = value
}

const checkScroll = () => {
    emits('checkScroll')
};

const scrollLeft = () => {
    emits('scrollLeft')
};

const scrollRight = () => {
    emits('scrollRight')
};

const getClaim = () => {
    emits('getClaim')
}
const goToDeposit = (amount : any) => {
     emits("goToDeposit", amount)
}

const openHistoryPopup = (data: any) => {
    histryPopupRef.value.open(data)
}
const resetHistoryData = () => {
    // historyList.value = []
}
defineExpose({
    setActive
})
</script>
<style scoped>
.firstRecharge {
    padding: 0px 30px;
    color: #fff;
}

.container {
    padding: 0px;
    position: relative;

}

.container>>>.van-tabs__nav {
    background: transparent;
    /* padding: 0 15px; */
    margin: 0 15px;
}

.container>>>.van-tab {
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.45);
    border-radius: 30px;
    font-size: 12px;
    margin: 5px;
    height: 35px;
    padding: 0 15px;
}

.container>>>.van-tab.van-tab--active {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    color: #12151A;
    font-weight: 500;
}

.container>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}

.content {
    color: #fff;
    padding: 15px;
}

.image-wrapper {
    /* position: relative;
    display: inline-block; */
}

.bottom_text {
    padding: 0px 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
}

.bg-top-img {
    width: 100%;
    padding-top: 3rem;
}

.scroll-btn {
    position: absolute;
    font-size: 24px;
    color: white;
    cursor: pointer;
    z-index: 1000;
    border-radius: 50%;
    user-select: none;

}

.scroll-btn img {
    width: 10%;
    z-index: 200;
}

.scroll-btn.left {
    left: 50vw;
    width: 4%;
}

.scroll-btn.right {
    right: 0;
}

.right img {
    transform: rotate(180deg) !important;
}
.immidiateDepositBtn{
    display: flex;
    justify-content: center;
}
.depositBtn {
    color: #000;
    background-image: linear-gradient(99deg, #FCD7A1 0%, #D17836 100%);
    border-radius: 10px;
    padding: 10px;
    width: 75%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 15px;
}
</style>